import { firestoreAction } from 'vuexfire';
import { db } from '@/plugins/firebaseDB';

const initialState = {
  sprints: [],
};

const getters = {
  getSprints: mutableState => mutableState.sprints,
  getSprint: state => index => state.sprints.find(sprint => sprint.id === index),
  getActiveSprint: state => state.sprints.find(sprint => sprint.active === true),
};

const mutations = {
  createSprint: (state, sprint) => {
    db.collection('sprints').add(sprint);
  },
  updateSprint: (state, sprint) => {
    db.collection('sprints').doc(sprint.id).update(sprint);
  },
  deleteSprint: (state, sprint) => {
    db.collection('sprints').doc(sprint.id).delete();
  },
};

const actions = {
  bindSprints: firestoreAction(({ bindFirestoreRef }) => bindFirestoreRef('sprints', db.collection('sprints').orderBy('start'))),
  createSprint: (context, sprint) => {
    context.commit('createSprint', sprint);
  },
  updateSprint: (context, sprint) => {
    context.commit('updateSprint', sprint);
  },
  deleteSprint: (context, sprint) => {
    context.commit('deleteSprint', sprint);
  },
};

export default {
  state: initialState,
  mutations,
  actions,
  getters,
};
